export const fuelContainerUnits = [
  {
    label: 'Mililitres',
    value: 'mililitres',
    suffix: 'mL',
  },
  {
    label: 'Litres',
    value: 'litres',
    suffix: 'L',
  },
  {
    label: 'Grams',
    value: 'grams',
    suffix: 'g',
  },
  {
    label: 'Kilograms',
    value: 'kilograms',
    suffix: 'Kg',
  },
  {
    label: 'Other',
    value: 'other',
    suffix: '',
  },
];

/**
 * Resolve the short-form unit suffix for a fuel/chemical container_unit value.
 *
 * @param {string} value Container unit value (e.g. 'litres')
 * @param {string} [fallback] Fallback (e.g. asset.other_container_unit)
 * @returns {string}
 */
export const getFuelContainerUnitSuffix = (value, fallback = '') => {
  const match = fuelContainerUnits.find(u => u.value === value);
  if (match) return match.suffix;
  return fallback;
};
